<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 credit-list-section">
    <!-- <app-header></app-header> -->
    <div class="container-fluid div-height" *ngIf="!showOrg">

      <div class="row">
        <span class="prev-page"><a routerLink="/overview">Home</a></span>
        <img class="separator mr-2 ml-2 mt-2" src="../../../assets/images/seperator.png">
        <span class="curr-page"><a routerLink="/credits">Credit Points</a></span>
      </div>

      <div class="row row-1">
        <h5>Credit Points</h5>
      </div>

      <div class="row row-2">
        <div class="col-sm-4">
          <p>My Total Credit Points</p>
          <p class="output">{{creditList?.allocated}}</p>
          <p class="request" (click)="RequestCreditpoints()">Request Credit Points</p>
        </div>
        <div class="col-sm-4">
          <p>Points Spent</p>
          <p class="spentOutput">{{creditList?.spent}}</p>
        </div>
        <div class="col-sm-4">
          <p>Balance</p>
          <p class="output">{{creditList?.remaining}}</p>
        </div>
      </div>

      <div class="row row-3" style="padding-right: 70px;">
        <div class="col-5">
          <p>Organisation Credit Points</p>


          <p class="org">{{aggregatedTotal(tenantDetails?.data?.totalCreditPoint,tenantDetails?.data?.poolCreditPoint)}}
            <span>({{tenantDetails?.data?.totalCreditPoint}} complimentary + {{tenantDetails?.data?.poolCreditPoint}}
              purchased)</span>
          </p>


        </div>
        <div class="col-7 box">
          <div class="block-1">
            <div class="d-flex " [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #p="ngbPopover"
              (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)"
              popoverClass='dash-popover dashboard-popover'
              class=" borders-right padding-left-meeting organization select-box">
              Organization
              <span class="d-flex justify-content-end"><img src="/assets/images/Path.png"
                  class="padding-left-image pr-3 justify-content-between" /></span>
              <!-- <div class="all">{{selectedTenantName}}</div> -->

              <div class="all">{{selectedTenantName}} <span
                  *ngIf="multiSelecttenant.length > 1">+{{multiSelecttenant.length - 1}}</span></div>

              <div>
                <ng-template #popContent>
                  <div class="dashboard-popover ">
                    <div class="d-flex justify-content-between ">
                      <div>
                        <div class="row pb-2" *ngFor="let list of companyList;let i=index">

                          <div class="popover-content pl-3 email-width col-11" (click)="selectEmailid(list)"
                            [class]="multiSelecttenant.includes(list?.id)?'bold-font':'normal-font'">
                            {{list?.companyName}}
                          </div>
                          <div class="col-1">
                            <img src="/assets/images/tick.png"
                              *ngIf="multiSelecttenant.includes(list?.id) || (list.id == null && multiSelecttenant.length == 0)"
                              class="" loading="lazy" />

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </ng-template>
              </div>
            </div>
          </div>
          <div class="block-2">
            <div class=search-area>
              <img src="../../../assets/images/search.png">
              <input type="search" placeholder="Type here to search..." [(ngModel)]="searchTerm">
            </div>

          </div>
        </div>
      </div>

      <ng-container *ngIf="tenantDetail && tenantDetail?.length>0 && tenantDetail !== undefined; else noTenantList">
        <div *ngFor="let list of tenantDetail | filter:searchTerm | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:tenantDetail?.length }" class="row row-4 ">
          <div class="col-sm-2">
            <p class="icon">{{generateInitials(list?.companyName)}}</p>
          </div>
          <div class="col-sm-5">
            <a (click)="showOrgSection(list)" [ngStyle]="{'cursor': 'pointer'}">
              <!-- <a [routerLink]="['/credit/cla/org']" [state] = list> -->
              <p class="name">{{list?.companyName}}</p>
            </a>
          </div>
          <div class="col-sm-5 block2">
            <div>
              <p class="title">complimentary</p>
              <p>{{getPoints(list?.t0100CreditPoints, 'spent', 1)}}/{{getPoints(list?.t0100CreditPoints, 'total', 1)}}
                balance</p>
            </div>
            <div class="verticleLine"></div>
            <div>
              <p class="title">purchased</p>
              <p>{{getPoints(list?.t0100CreditPoints, 'spent', 2)}}/{{getPoints(list?.t0100CreditPoints, 'total', 2)}}
                balance</p>
            </div>
          </div>




        </div>
        <!-- <div class="row row-5" *ngIf="showPagination">
          <ngb-pagination [collectionSize]="tenantDetails?.data.tenants.length" [maxSize]="5" [(page)]="page"
            [pageSize]="pageSize" (pageChange)=refreshPagination()>
          </ngb-pagination>
        </div> -->



        <!-- <div class="d-flex justify-content-center pagination-section mt-4 mb-5" *ngIf="teams?.list?.length>10">
          <div class="row d-flex pagination-border">
            <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
              class="d-flex justify-content-center">
            </pagination-controls>
            <div class="pr-3 ratio-class pt-1">
              {{team?.length}}/{{teams?.list?.length}}</div>
          </div>
        </div> -->

      </ng-container>

      <div class="d-flex justify-content-center mt-4 mb-4" style="margin:30px 0px">
        <div class="row d-flex pagination-border">
          <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
            class="d-flex justify-content-center">
          </pagination-controls>
          <div class="pr-3 ratio-class pt-1">
            {{tenant?.length}}/{{tenantDetail?.length}}</div>
        </div>

      </div>
      <ng-template #noTenantList>
        <div class="row row-4">
          <div class="col-sm-12">
            <p class="name">No Tenants Available</p>
          </div>
        </div>
      </ng-template>
    </div>

    <app-organisation-detail *ngIf="showOrg" (refreshCredit)="refreshCredit($event)" [tenant]="tenantDetailForOrg">
    </app-organisation-detail>
  </div>

</div>



